import React from "react";
import "../../Styles/yellowcalf.css/Balance_Report.css";

function Balance_Report() {
  return (
    <div
      className="balance-report-container"
      style={{ paddingTop: "25px" }}
    >
      <div className="balance-report-header-section">
        <div className="balance-report-header-box">
          <h3 className="balance-report-header-title">
            Balance Report
          </h3>

          <div className="balance-report-export-section">
            <button className="balance-report-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>

            <ul className="balance-report-export-list">
              <li>
                <a href="#">Save as PDF</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="balance-report-filter-section">
        <div className="balance-report-filter-row">
          <div className="balance-report-filter-item">
            <select id="grade" className="balance-report-select">
              <option value="">Select Term/semester</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
            </select>
          </div>

          <div className="balance-report-filter-item">
            <select id="division" className="balance-report-select">
              <option value="">Select Grade</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
            </select>
          </div>

          <div className="balance-report-filter-item">
            <select id="students" className="balance-report-select">
              <option value="">Select division</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
            </select>
          </div>

          <div className="balance-report-filter-item">
            <button
              type="submit"
              className="balance-report-btn balance-report-btn-search"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Balance_Report;
